/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable prefer-rest-params */
import { isTelegramView, isVkView } from '@/utils/miniapps'

import { Mode } from '@/types/environment'

export default defineNuxtPlugin({
  parallel: true,
  setup({ $config }) {
    const { MODE, YM_ID } = $config.public

    // Метрика только для телеграм-бота и только для dev
    if (
      (!isTelegramView() && !isVkView()) ||
      [Mode.DEVELOPMENT].includes(MODE as Mode)
    ) {
      return // Вставляем скрипт Метрики
    }

    // Добавляем скрипт на сайт
    ;(function (m, e, t, r, i, k, a) {
      m[i] =
        m[i] ||
        function () {
          ;(m[i].a = m[i].a || []).push(arguments)
        }
      m[i].l = 1 * new Date()
      for (let j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return
        }
      }
      ;((k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a))
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')
    window?.ym(YM_ID, 'init', {
      webvisor: true,
      clickmap: true,
      ecommerce: 'dataLayer',
      accurateTrackBounce: true,
      trackLinks: true,
    })

    // Отправялем "запуск miniapps"
    if (isTelegramView()) {
      window?.ym(YM_ID, 'reachGoal', 'twa_open')
    }

    if (isVkView()) {
      window?.ym(YM_ID, 'reachGoal', 'vkwa_open')
    }
  },
})
